import { Vraag, Controltype } from '@models/claims';
import { VraagboomAntwoord, IBaseVraagboomResultaat } from '@models/vragenboom';
import cloneDeep from 'lodash/cloneDeep';

export class ResultaatMapper {
  static map(resultaat: VraagboomAntwoord<IBaseVraagboomResultaat>, vraag: Vraag): VraagboomAntwoord<IBaseVraagboomResultaat> {
    if (resultaat == null || resultaat.vraag == null || vraag == null) {
      return null;
    }

    if (resultaat.vraag.control !== vraag.control) {
      return null;
    }

    switch (vraag.control) {
      case Controltype.Tekst: {
        if (resultaat.antwoorden.length === vraag.antwoorden.length &&
          resultaat.antwoorden.every(a => vraag.antwoorden.some(va => va.variabeleWaarde === a.variabeleWaarde))) {
          let newResultaat: VraagboomAntwoord<IBaseVraagboomResultaat>;
          newResultaat = cloneDeep(resultaat);
          newResultaat.vraag = vraag;
          return newResultaat;
        }
        break;
      }
      case Controltype.Blob: {
        if (resultaat.vraag.antwoorden.length === vraag.antwoorden.length) {
          let newResultaat: VraagboomAntwoord<IBaseVraagboomResultaat>;
          newResultaat = cloneDeep(resultaat);
          newResultaat.vraag = vraag;
          return newResultaat;
        }
        break;
      }
    }

    return null;
  }
}
